import type { ReplayTeamColors } from "@Components/game/session-results/feedback/visualization/constants";
import { PLAYER_SIZE, TEAM_COLORS } from "@Components/game/session-results/feedback/visualization/constants";
import { Graphics as PixiGraphics } from "@pixi/graphics";
import { Graphics } from "@pixi/react";
import { useCallback } from "react";

interface IPlayerCircle {
  team: number | string;
  isPlayerCharacter?: boolean;
  teamColors?: ReplayTeamColors;
}

const PlayerCircle = ({ team, isPlayerCharacter = false, teamColors = TEAM_COLORS }: IPlayerCircle) => {
  const isHomeTeam = team === 0 || team === "0";
  const palette = isHomeTeam ? teamColors.home : teamColors.away;
  const baseColor = palette.primary;
  const borderWidth = isPlayerCharacter ? 1.5 : 1;

  const drawCircle = useCallback(
    (g: PixiGraphics) => {
      g.clear();
      g.lineStyle(borderWidth, 0xffffff, 1);
      g.beginFill(baseColor, 1.0);
      g.drawCircle(0, 0, PLAYER_SIZE);
      g.endFill();
    },
    [baseColor, borderWidth]
  );

  return <Graphics draw={drawCircle} />;
};

export default PlayerCircle;
